(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-sell-submission-intro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  const panel=document.querySelector('[data-rc-buylist-context]');
  if(!panel)return;
  const params=new URLSearchParams(window.location.search);
  const title=(params.get('rc_product')||'').trim().slice(0,300);
  if(!title)return;
  const rawUrl=(params.get('rc_url')||'').trim();
  let productUrl='';
  try{
    const candidate=new URL(rawUrl,window.location.origin);
    if(candidate.origin===window.location.origin&&candidate.pathname.includes('/products/'))productUrl=candidate.pathname;
  }catch(e){}
  const reference='Product: '+title+(productUrl?'\nProduct page: '+window.location.origin+productUrl:'');
  panel.querySelector('[data-rc-buylist-product]').textContent=title;
  panel.querySelector('[data-rc-buylist-reference]').textContent=reference;
  const back=panel.querySelector('[data-rc-buylist-back]');
  if(productUrl){back.href=productUrl;back.hidden=false;}
  panel.hidden=false;
  const quick=document.querySelector('[data-rc-buylist-quick]');
  if(quick){
    const field=quick.querySelector('[data-rc-buylist-field="product"]');
    const urlField=quick.querySelector('[data-rc-buylist-field="url"]');
    if(field)field.value=title;
    if(urlField)urlField.value=productUrl?window.location.origin+productUrl:'';
    quick.hidden=false;
  }

  const button=panel.querySelector('[data-rc-buylist-copy]');
  const feedback=panel.querySelector('[data-rc-buylist-feedback]');
  button.addEventListener('click',async function(){
    try{
      if(!navigator.clipboard||!navigator.clipboard.writeText)throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(reference);
      feedback.textContent='Copied to clipboard';
    }catch(e){feedback.textContent='Please select and copy the product details manually.';}
  });
});

  } catch(e) { console.error(e); }
})();
})();
